import { render, staticRenderFns } from "./ColmenarEditar.vue?vue&type=template&id=509a7254&scoped=true&"
import script from "./ColmenarEditar.vue?vue&type=script&lang=js&"
export * from "./ColmenarEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509a7254",
  null
  
)

export default component.exports